import { usePathname } from 'expo-router';

import { activeChatIdFromPath } from '@/lib/layout/sidebar-tab';

import { ChatConversation } from './ChatConversation.web';
import { ChatEmptyState } from './ChatEmptyState.web';

export function ChatShell() {
  const pathname = usePathname();
  const conversationId = activeChatIdFromPath(pathname);

  if (conversationId) {
    return <ChatConversation key={conversationId} conversationId={conversationId} />;
  }

  return <ChatEmptyState />;
}
